import React, { useEffect, useState } from "react";
import Header from "../../../../Componets/Header";
import Table from "../../../../Componets/Table";
import tables from "../../../../Data/Tables/Purchases/Refund/tables";
import headers from "../../../../Data/Tables/Purchases/Refund/headers";
import purchase_refund from "../../../../Data/purchase_refund.json";
import ActionButton from "../../../../Componets/Buttons/action";
import toast from "react-hot-toast";

const PurchasesRefundTable = () => {
  let header = headers;
  let head = tables;

  const [body, setBody] = useState();

  const fetchData = async () => {
    try {
      let data = [];

      purchase_refund?.map((value, index) => {
        data?.push({
          Number: value?.return,
          Purchase: value?.number,
          Date: value?.date,
          Amount: value?.amount,
          Payment: value?.payment,
          Action: <ActionButton edit={`/`} delete="/" />,
        });
      });

      setBody(data);
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const formdata = async (data) => {
    console.log(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header header={header} formdata={formdata}>
      <Table head={head} body={body} />
    </Header>
  );
};

export default PurchasesRefundTable;
